import React from 'react';

const About = () => {
    return (
        <div className='about'>
        </div>
    );
};

export default About;